import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import UserProfile from 'app/modules/auth/components/profile/UserProfile'
import UserList from 'app/modules/auth/user/UserList'
import CreateUser from 'app/modules/auth/user/CreateUser'
import EditUser from 'app/modules/auth/user/EditUser'
import RoleList from 'app/modules/auth/role/RoleList'
import CreateRole from 'app/modules/auth/role/CreateRole'
import EditRole from 'app/modules/auth/role/EditRole'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import TopBarProgress from 'react-topbar-progress-indicator'
import LecturerUserList from 'app/modules/auth/user/LecturerUserList'
import StudentUserList from 'app/modules/auth/user/StudentUserList'

const PrivateRoutes = () => {
  const ToolsRoutes = lazy(() => import('app/modules/admin/tools/ToolsRoutes'))
  const CampusRoutes = lazy(() => import('app/modules/admin/campus/CampusRoutes'))
  const AcademicsRoutes = lazy(() => import('app/modules/admin/academics/AcademicsRoutes'))
  const AdminRoutes = lazy(() => import('app/modules/admin/AdminRoutes'))
  const FinanceRoutes = lazy(() => import('app/modules/finance/FinanceRoutes'))
  const StudentRoutes = lazy(() => import('app/modules/admin/student/StudentRoutes'))
  const OsRoutes = lazy(() => import('app/modules/online-student/OnlineStdRoutes'))
  const LecturerRoutes = lazy(() => import('app/modules/lecturer/LecturerRoute'))
  const ChatRoutes = lazy(() => import('app/modules/chatting/ChatRoutes'))
  const ParentRoutes = lazy(() => import('app/modules/parent/ParentRoutes'))
  const OnlineRoutes = lazy(() => import('app/modules/admin/online/OnlineRoutes'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registration */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />

        {/* Dashboard */}
        <Route path='dashboard' element={<DashboardWrapper />} />

        {/* User Routes */}
        <Route path='/users-list' element={<UserList />} />
        <Route path='/user/create' element={<CreateUser />} />
        <Route path='/user-edit/:id' element={<EditUser />} />
        <Route path='/lecturer-users' element={<LecturerUserList />} />
        <Route path='/student-users' element={<StudentUserList />} />

        {/* Role Routes */}
        <Route path='/roles-list' element={<RoleList />} />
        <Route path='/role/create' element={<CreateRole />} />
        <Route path='/role-edit/:id' element={<EditRole />} />
        <Route path='/profile' element={<UserProfile />} />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />

        <Route
          path='tools/*'
          element={
            <SuspensedView>
              <ToolsRoutes />
            </SuspensedView>
          }
        />

        <Route
          path='campuses/*'
          element={
            <SuspensedView>
              <CampusRoutes />
            </SuspensedView>
          }
        />

        <Route
          path='academics/*'
          element={
            <SuspensedView>
              <AcademicsRoutes />
            </SuspensedView>
          }
        />

        <Route
          path='admin/*'
          element={
            <SuspensedView>
              <AdminRoutes />
            </SuspensedView>
          }
        />

        <Route
          path='finance/*'
          element={
            <SuspensedView>
              <FinanceRoutes />
            </SuspensedView>
          }
        />

        <Route
          path='student/*'
          element={
            <SuspensedView>
              <StudentRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='os/*'
          element={
            <SuspensedView>
              <OsRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='parent/*'
          element={
            <SuspensedView>
              <ParentRoutes />
            </SuspensedView>
          }
        />

        <Route
          path='lec/*'
          element={
            <SuspensedView>
              <LecturerRoutes />
            </SuspensedView>
          }
        />
        <Route
          path='chat/*'
          element={
            <SuspensedView>
              <ChatRoutes />
            </SuspensedView>
          }
        />

        <Route
          path='online/*'
          element={
            <SuspensedView>
              <OnlineRoutes />
            </SuspensedView>
          }
        />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
